import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import CRM from "../../../../../utils/CrmService";

export default function CjbGestoresCarteraForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.cbr_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activo, setActivo] = useState(record.cbr_id > 0 ? record.cbr_activo : 0);

  useEffect(() => {
    setCurId(record.cbr_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span:4 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await CRM.sendCjbGestoresCartera(
      currentUser,
      curId,
      activo,
      "CjbGestoresCartera",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE GESTORES DE CARTERA",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE GESTORES DE CARTERA",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="CjbGestoresCartera"
      onFinish={guardarCambios}
      initialValues={{
        cbr_nombre: record.cbr_id > 0 ? record.cbr_nombre : "",
        cbr_comision: record.cbr_id > 0 ? record.cbr_comision : "",
        cbr_activo: record.cbr_id > 0 ? record.cbr_activo : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.cbr_id > 0
            ? "ACTUALIZAR GESTORES DE CARTERA"
            : "AGREGAR GESTORES DE CARTERA"}
        </Title>
      </Form.Item>
      <Form.Item
        name="cbr_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.cbr_id > 0 ? record.cbr_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="cbr_comision"
        label="Comision"
        rules={[
          {
            required: true,
            message: "La comision es obligatoria",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "100px" }}
          value={record.cbr_id > 0 ? record.cbr_comision : ""}
        />
      </Form.Item>
      <Form.Item
        name="cbr_activo"
        label="Activo"
        wrapperCol={{ span: 10 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal" size={10}>
        <Switch
            checked={activo}
            onChange={(val) => setActivo(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
